/**
 * @type {import('vanilla-cookieconsent').CookieConsentConfig}
 */
const config = {
    cookie: {
        name: 'privacy',
        useLocalStorage: true,
    },

    disablePageInteraction: true,

    guiOptions: {
        consentModal: {
            layout: "cloud",
            position: "bottom right",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: "bar wide",
            position: "right",
            equalWeightButtons: true,
            flipButtons: true
        }
    },

    onFirstConsent: () => {
      console.log('onFirstAction fired');
    },

    onConsent: () => {
      console.log('onConsent fired ...');
    },

    onChange: () => {
      console.log('onChange fired ...');
    },

    categories: {
      necessary: {
        readOnly: true,
        enabled: true,
      },
      analytics: {
        enabled: true,
        autoClear: {
          cookies: [
            {
              name: /^(_ga|_gid)/,
            },
          ],
        },
      }
    },

    language: {
      default: 'en',

      translations: {
        en: {
          consentModal: {
            title: "É necessário definir as autorizações de cookies",
            description:
              "<strong>Livrete.pt</strong> utiliza cookies ou tecnologias semelhantes para fins técnicos e, com o seu consentimento, para outros fins de estatística como descrito no política de privacidade.<br> Pode conceder, recusar ou retirar livremente o seu consentimento em qualquer altura.",
            acceptAllBtn: 'Aceita',
            acceptNecessaryBtn: 'Rejeita',
            showPreferencesBtn: 'Suas preferencias',
            closeIconLabel: 'Rejeita todas e fechar',
            footer: `
                                    <a href="https://driver.livrete.pt/politica.html" target="_blank">Politica de Privacidade</a>
                    `,
          },
          preferencesModal: {
            title: 'As suas opções de privacidade',
            acceptAllBtn: 'Aceita todos',
            acceptNecessaryBtn: 'Rejeita todos os opcionais',
            savePreferencesBtn: 'Guarda as minhas preferências',
            sections: [
              {
                title: 'Uso de cookies',
                description:
                  "Neste painel poderá expressar algumas preferências relacionadas com o tratamento dos seus dados pessoais. Você pode revisar e alterar as escolhas expressas a qualquer momento, reaparecendo este painel através do link fornecido. Para negar o seu consentimento para as atividades de processamento específicas descritas abaixo, desative os botões ou use o botão “Rejeitar tudo” e confirme que deseja salvar suas escolhas.",
              },
              {
                title: 'Cookies estritamente necessários',
                description:
                  'Somente aqueles necessários para acesso ao livrete.pt',
                linkedCategory: 'necessary',
              },
              {
                title: 'Cookies de desempenho e analíticos',
                description:
                  'Aqueles necessários para a análise estatiticas de acesso e performance.',
                linkedCategory: 'analytics',
                cookieTable: {
                  headers: {
                    name: 'Cookie',
                    domain: 'Domain',
                    desc: 'Description',
                  },
                  body: [
                    {
                      name: '_ga',
                      domain: "<a href='https://marketingplatform.google.com/about/analytics/' target='_blank'>Google Analitycs</a>",
                      desc: 'Insights essenciais do cliente',
                    },
                  ],
                },
              },
              {
                title: 'Mais informações',
                description:
                  'Para qualquer dúvida em relação à nossa política de cookies e suas escolhas, <a class="cc__link" href="livrete.pt">entre em contato comigo</a>.',
              },
            ],
          },
        },
      },
    },
  };

  export default config;
